import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  MicrosoftSecurityGroupOption,
  MicrosoftSecurityGroupSettings,
  PrivilegedTenant,
} from '../../../shared/models/generated/ziroModels';
import { MicrosoftSecurityGroupSettingsResource } from '../../../shared/resources/microsoft-security-group-settings.resource';
import { MsSecurityGroupManagementEntity } from './security-group-management-form.component';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TenantNavigationService } from '../../services/tenant-navigation.service';

@Component({
  selector: 'ziro-security-group-management',
  templateUrl: './security-group-management.component.html',
  styleUrls: ['../../admin-page.scss'],
  providers: [MicrosoftSecurityGroupSettingsResource, TenantNavigationService],
  standalone: false,
})
export class SecurityGroupManagementComponent implements OnInit, OnDestroy {
  private _microsoftSecurityGroupsSettingsResource = inject(MicrosoftSecurityGroupSettingsResource);
  private _route = inject(ActivatedRoute);
  private _tenantNavigationService = inject(TenantNavigationService);

  isLoading = true;
  formEntity: MsSecurityGroupManagementEntity;
  securityOptions: string[] = [];
  securityGroups: MicrosoftSecurityGroupOption[];
  tenantInfo: PrivilegedTenant;

  private _subs = new Subscription();

  ngOnInit(): void {
    const tenantNavigationSub = this._tenantNavigationService.getTenantInfo(this._route).subscribe((tenantInfo) => {
      this.tenantInfo = tenantInfo;
      this.updateBreadcrumbs();
      this.loadSecurityGroupSettings();
    });

    this._subs.add(tenantNavigationSub);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private updateBreadcrumbs(): void {
    this._tenantNavigationService.buildTenantBreadcrumbs(this.tenantInfo, [
      { label: 'tkey;admin.microsoft.security_group_management.title' },
    ]);
  }

  private loadSecurityGroupSettings(): void {
    this._microsoftSecurityGroupsSettingsResource.get(this.tenantInfo.tenantId).subscribe({
      next: (securityGroupSettings: MicrosoftSecurityGroupSettings) => {
        this.formEntity = {
          readOnlySecurityGroupList: [...securityGroupSettings.readOnlySecurityGroupList],
          writeSecurityGroupList: [...securityGroupSettings.writeSecurityGroupList],
        };
        this.isLoading = false;
      },
    });
  }
}
